import controller from './add.controller';

const template = require('./add.html');

export default {
    bindings: {
        onSubmit: '&',
        parentId: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folder-tree/add-folder/add.component.js